export default __webpack_public_path__ + "static/media/separator_text.2185b944.svg";